export default __webpack_public_path__ + "static/media/system_03_08.7c0a3937.jpg";